export default __webpack_public_path__ + "static/media/empty-search-tasks-table.31c94200.svg";